import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SubscriptionType } from '../../../types/misc';
import useActiveSubscription from '../../../hooks/business/useActiveSubscription';
import useSelectedBusiness from '../../../hooks/business/useSelectedBusiness';
import TrialBanner from '../../components/misc/TrialBanner';
import { SubscriptionSelector } from '../../components/selection-lists/SubscriptionSelector';

export function SubscriptionsPage() {
  const { t } = useTranslation('', { keyPrefix: 'page.settings.subscriptions' });
  const activeSubscription = useActiveSubscription();
  const navigate = useNavigate();
  const business = useSelectedBusiness();

  const handleSubscriptionAction = (subscriptionType: SubscriptionType) => {
    if (activeSubscription === subscriptionType) {
      navigate('/subscriptions/manage');
    } else {
      navigate('/subscriptions/upgrade', {
        state: { changePaymentMode: false, subscriptionType },
      });
    }
  };

  function shouldShowTrialBanner(): boolean {
    if (!business?.trialEndDate || !business?.trialType || business?.subscription?.subscriptionType)
      return false;
    const now = new Date();
    const trialEnd = new Date(business.trialEndDate);
    const daysLeft = Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    return trialEnd.getTime() > now.getTime() && daysLeft < 31;
  }

  return (
    <>
      {business && business.trialEndDate && business.trialType && shouldShowTrialBanner() && (
        <TrialBanner trialEndDate={new Date(business.trialEndDate)} plan={business.trialType} />
      )}

      <div className="mx-auto max-w-6xl">
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold text-primary-900">{t('title')}</h1>
          <p className="text-lg text-primary-900 opacity-75">{t('subtitle')}</p>
        </div>

        <SubscriptionSelector
          selectedSubscription={activeSubscription}
          mode="cards"
          showActionButtons
          selectedActionText={t('manageSubscription')}
          unselectedActionText={t('subscribe')}
          onActionClick={handleSubscriptionAction}
        />
      </div>
    </>
  );
}
